var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"circle-border"}),_vm._v(" "),_c('div',{staticClass:"circle"},[_c('div',{staticClass:"error"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }